import React, { Component } from "react";
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class indexComingSoon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0
        };
        this.countdownInterval = null;
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.startCountdown();
    }

    componentWillUnmount() {
        clearInterval(this.countdownInterval);
    }

    startCountdown = () => {
        this.countdownInterval = setInterval(() => {
            const launchDate = new Date("2025-02-21T12:00:00").getTime();
            const now = new Date().getTime();
            const difference = launchDate - now;

            if (difference > 0) {
                const days = Math.floor(difference / (1000 * 60 * 60 * 24));
                const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((difference % (1000 * 60)) / 1000);

                this.setState({ days, hours, minutes, seconds });
            } else {
                clearInterval(this.countdownInterval);
                this.setState({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                    message: "The launch has started!"
                });
            }
        }, 1000);
    };

    render() {
        const { isLoading, days, hours, minutes, seconds, message } = this.state;

        return (
            <>
                {isLoading && <Loader />}
                <Header />

                <div className="coming-soon-container">
                    <div className="logo">
                        <img src="/logo_4.png" alt="Logo" className="logo-img" />
                        <p className="date-text">Launching on 21st February 2025 at 12:00 PM</p>
                    </div>

                    <div className="timer-container" id="timer-container">
                        {message ? (
                            <h2>{message}</h2>
                        ) : (
                            <>
                                <div className="timer-box">
                                    <span>{days}</span>
                                    <label>Days</label>
                                </div>
                                <div className="timer-box">
                                    <span>{hours}</span>
                                    <label>Hours</label>
                                </div>
                                <div className="timer-box">
                                    <span>{minutes}</span>
                                    <label>Minutes</label>
                                </div>
                                <div className="timer-box">
                                    <span>{seconds}</span>
                                    <label>Seconds</label>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <Footer />

                <style jsx>{`
                    .coming-soon-container {
                        background-color: #000;
                        color: #fff;
                        text-align: center;
                        min-height: 70vh;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: space-between;
                        font-family: 'Poppins', sans-serif;
                        padding: 2rem 0;
                    }

                    .logo {
                        margin-top: 3rem;
                    }

                    .logo-img {
                        max-width: 400px;
                        height: auto;
                    }

                    .date-text {
                        font-size: 1.5rem;
                        font-weight: bold;
                        margin-top: 1rem;
                        color: #fff;
                        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4);
                    }

                    .timer-container {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        gap: 30px;
                        margin: 3rem 0;
                    }

                    .timer-box {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        font-weight: bold;
                    }

                    .timer-box span {
                        font-size: 3rem;
                        margin-bottom: 10px;
                    }

                    .timer-box label {
                        font-size: 1rem;
                        color: #dcdcdc;
                    }
                `}</style>
            </>
        );
    }
}

export default withRouter(connect(null, {})(indexComingSoon));
